import { DispatchBoardQueueStatus } from "app/data/city-delivery/dispatch-board/models";
import React, { memo } from "react";
import { cn } from "services/common/className";
import Tag from "ui-components/molecules/tag/tag";

export interface DispatchQueueLoadStatusProps {
    dispatchLoadStatus: DispatchBoardQueueStatus
}

const DispatchQueueLoadStatus: React.FC<DispatchQueueLoadStatusProps> = memo((props) => {

    const getStatus = (status: DispatchBoardQueueStatus) => {
        if (status === DispatchBoardQueueStatus.READY_TO_ASSIGN) return <Tag
          mix={cn("dispatch-queue-load-status")("ready-to-assign")}
        >
          Ready to Assign
        </Tag>;
        else if (status === DispatchBoardQueueStatus.LOADING) return <Tag
          mix={cn("dispatch-queue-load-status")("loading")}
        >
          Loading
        </Tag>;
        else if (status === DispatchBoardQueueStatus.READY_TO_CLOSE) return <Tag
          mix={cn("dispatch-queue-load-status")("ready-to-close")}
        >
          Ready to Close
        </Tag>;
        else if (status === DispatchBoardQueueStatus.READY_TO_DISPATCH) return <Tag
          mix={cn("dispatch-queue-load-status")("ready-to-dispatch")}
        >
          Ready to Dispatch
        </Tag>;
        else if (status === DispatchBoardQueueStatus.DISPATCHED) return <Tag
          mix={cn("dispatch-queue-load-status")("dispatched")}
        >
          Dispatched
        </Tag>;
        else return status;
      }

    return getStatus(props.dispatchLoadStatus);
});

export default DispatchQueueLoadStatus;
